<template>
  <div class="wrapper">
    <Header />
    <slot />
    <Footer />
  </div>
</template>

<style>
@media (max-width: 767px) {
  .container {
    width: 100%;
    padding: 1rem;
    margin: 0;
  }
}
</style>
